// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconPeoplePartners = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M11 7a3 3 0 11-6 0 3 3 0 016 0M9 7a1 1 0 11-2 0 1 1 0 012 0m10 0a3 3 0 11-6 0 3 3 0 016 0m-2 0a1 1 0 11-2 0 1 1 0 012 0m-5.009 6.376C9.4 11.41 5.558 11.404 3 14.314V20h18v-5.687c-2.232-2.538-6.124-3.188-9.009-.937M5 15.137V18h6v-2.858c-1.68-1.439-4.166-1.601-6-.005m8 0V18h6v-2.858c-1.68-1.439-4.166-1.601-6-.005"
    />
  );
export default SvgIconPeoplePartners;
